import type { ReactNode } from 'react';

export type Status =
  | 'healthy'
  | 'degraded'
  | 'offline'
  | 'live'
  | 'playing'
  | 'promo'
  | 'idle'
  | 'unpaired'
  | 'starting'
  | 'expiring'
  | 'upcoming';

export function StatusDot({ status, glow, small }: { status: Status; glow?: boolean; small?: boolean }) {
  return <span aria-hidden="true" className={`hv-dot hv-dot--${status}${glow ? ' hv-dot--glow' : ''}${small ? ' hv-dot--sm' : ''}`} />;
}

/** Rounded status pill with a leading dot. */
export function StatusPill({ status, children, dot = true }: { status: Status; children: ReactNode; dot?: boolean }) {
  return (
    <span className={`hv-pill hv-pill--${status}`}>
      {dot && <StatusDot status={status} small />}
      {children}
    </span>
  );
}

export function Badge({ children, tone = 'blue' }: { children: ReactNode; tone?: 'blue' | 'green' | 'danger' }) {
  return <span className={`hv-badge${tone === 'blue' ? '' : ` hv-badge--${tone}`}`}>{children}</span>;
}
